module.exports = __webpack_public_path__ + "static/media/leisure.60c86a36.jpg";